import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ReportService } from '../../report.service';

@Component({
    selector: 'app-res-adr-report',
    templateUrl: './res-adr-report.component.html',
    styleUrls: ['./res-adr-report.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ResADRReportComponent implements OnInit {
	constructor(
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		private reportService: ReportService,
	) {
		
	}

	columns = [
		{ field: 'addressDevelopmentName', header: 'Development', width: 'auto' },
		{ field: 'propertyRankName', header: 'Property Class', width: 'auto' },
		{ field: 'propertyCode', header: 'Property', width: 'auto' },
		{ field: 'bedrooms', header: 'Bedroom', width: 'auto' },
		{ field: 'reservationId', header: 'Res #', width: 'auto' },
		{ field: 'checkInDate', header: 'Check-In' },
		{ field: 'checkOutDate', header: 'Check-Out' },
		{ field: 'saleDate', header: 'Booking' },
		{ field: 'prebookDays', header: 'Lead Time' },
		{ field: 'numberOfNightsStay', header: 'LOS' },
		{ field: 'nightlyRateTTL', header: 'totalRent' },
		{ field: 'nightlyRate', header: 'ADR' },
		{ field: 'refSrcName', header: 'Channel' },
		{ field: 'resStatusName', header: 'Res Status' },
	  ];

	reservations: any;
	reservationsDashboardState: any;
	loading : boolean = false;
	defaultStartDate: Date
	defaultEndDate: Date

	ngOnInit(): void {
		try {
			this.defaultStartDate = new Date();
			this.defaultStartDate = new Date(this.defaultStartDate.getFullYear(), 0, 1); // jan 1
			this.defaultEndDate = new Date();
			this.defaultEndDate = new Date(this.defaultEndDate.getFullYear(), 0, 2);
			let reportSearchApi = {
				shortTermRentalIdList : [1]
			}
			this.fetchReservations(reportSearchApi);
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	onSearchSubmit(searchForm: any) {
		this.fetchReservations(searchForm);
	}

	fetchReservations(reportSearchApi) {
		try {
			this.loading = true;
			this.reportService.getResAdrReport(reportSearchApi)
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.reservations = res.data.reservations;
						this.loading = false;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
						this.loading = false;
					},
					() => { 
						this.loading = false;
					});
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

}
